import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassCategory extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'CompassCategory'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      categoryId: null,
      icon: '',
      color: '',
      title: '',
      description: '',
      position: 0,
      isDefault: false,
      mediaId: null,
    }
  }
}
const servicePath = 'compass-categories'
const servicePlugin = makeServicePlugin({
  Model: CompassCategory,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
